import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

// Reviews duck
import {
  getReviews,
  getReviewsError,
  getReviewsInProgress,
  getReviewsPagination,
} from '../containers/ReviewsPage/ReviewsPage.duck';

export const useReviews = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const reviews = useSelector(getReviews);
  const loading = useSelector(getReviewsInProgress);
  const error = useSelector(getReviewsError);
  const pagination = useSelector(getReviewsPagination);

  // Determine if no results found
  const notFound = useMemo(() => {
    return !loading && reviews.length === 0;
  }, [loading, reviews.length]);

  const clearBrandSearchParam = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('pub_brandSlug') || searchParams.get('brandName')) {
      history.replace(location.pathname);
    }
  }, [history, location.pathname, location.search]);

  // Handle going back
  const handleGoBack = useCallback(() => {
    clearBrandSearchParam();
    history.push('/reviews');
  }, [dispatch, history, clearBrandSearchParam]);

  return useMemo(
    () => ({
      reviews,
      loading,
      error,
      notFound,
      pagination,
      handleGoBack,
    }),
    [reviews, loading, error, notFound, pagination, handleGoBack]
  );
};
